define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/dom-style",
	"dojo/dom-geometry",
	"dijit/layout/AccordionContainer"
], function(array,declare,domStyle,domGeometry,AccordionContainer) {

	return declare(AccordionContainer,{
		layout: function(){
			//overriding dojo accordion to make sure the selected panel is always in expanded mode
			var openPane = this.selectedChildWidget;

			if(!openPane){
				return;
			}

			var wrapperContainerNode = openPane._wrapperWidget.containerNode;

			this.inherited(arguments);
			if(openPane && wrapperContainerNode.children.length){
				domStyle.set(wrapperContainerNode.firstChild,{height:"auto"});
			}
		}
	});
});
